enum CustomConfigs {
  DisableGTM = 'vdp-disable-gtm',
  EnableDebug = 'merch-enable-debug',
  DisableLazyLoad = 'vdp-disable-lazy-load',
  DisableSpinner = 'vdp-disable-spinner',
  enableGeicoDiscount = 'enable-geico-discount',
  enableNewCarConfiguratorV2 = 'enable-new-car-configurator-v2',
  enableOECDiscountsApi = 'enable-oec-discounts-api',
  enableRootDiscount = 'enable-root-discount',
  enableTestDriveCenterDealershipHome = 'enable-test-drive-center-dealership-home',
  EnableMfeDebug = 'merch-enable-mfe-debug',
  FeatureBranch = 'feature-branch',
  ForceServerError = 'force-server-error',
  MockVehicle = 'vdp-mock-vehicle',
  PriceDrop = 'show-price-drop-banner',
  RemoveFooter = 'merch-remove-footer',
  RemoveHeader = 'merch-remove-header',
  shouldUseTitleCasing = 'should-use-title-casing',
  showShaqvanaVideosSection = 'show-shaqvana-videos-section',
  useCatalogOEMData = 'use-catalog-oem-data',
  useVaultWhyBuy = 'use-vault-why-buy',
  withModalOpen = 'wmo'
}

export default CustomConfigs;
